import {
  type TCreateStructuredLogUserEngagement,
  type IStructuredLogUserEngagement,
} from '../types/adscopilot-structured-log-types';
import { type ICreateStructuredLogParams } from '../types/structured-log-types';
import { createStructuredLogBase } from './create-structured-log-base';

const getStructuredLogMessageReaction = (activity: ICreateStructuredLogParams['activity']): Partial<IStructuredLogUserEngagement> => {
  const currentReaction = (activity as any)?.reactionsAdded?.[0]?.type as 'ThumbsUp' | 'ThumbsDown' | undefined;
  const previousReaction = (activity as any)?.reactionsRemoved?.[0]?.type as 'ThumbsUp' | 'ThumbsDown' | undefined;

  return {
    activityType: currentReaction ?? previousReaction,
    activityText: currentReaction ? `User reaction: ${currentReaction}.` : `User reaction reverted: ${previousReaction}.`,
    additionalContext: {
      previousReaction,
    },
  };
};

export const createStructureLogUserEngagement: TCreateStructuredLogUserEngagement = (params) => {
  const { activity } = params;

  const structuredLogBase = createStructuredLogBase(params);

  let userEngagementStructuredLog: Partial<IStructuredLogUserEngagement> = {};

  if ((activity as any)?.type === 'messageReaction') {
    userEngagementStructuredLog = getStructuredLogMessageReaction(activity);
  }

  return {
    ...structuredLogBase,
    responder: 'User',
    activityId: activity.id,
    replyToId: activity.replyToId,
    activityType: 'Unknown', // if not handled, set to 'Unknown'
    activityText: 'Unknown user engagement activity recorded.', // if not handled, add default text for unknown activity type
    additionalContext: { activity }, // if not handled, add the activity to additional context
    ...userEngagementStructuredLog,
  };
};
